import { Component } from '@angular/core';

@Component({
  selector: 'app-student-form-link',
  templateUrl: './student-form-link.component.html',
  styleUrls: ['./student-form-link.component.scss']
})
export class StudentFormLinkComponent {

}
